<script setup>
    import { ref, onMounted } from "vue";
    import ButtonComponent from "../Shared/ButtonComponent.vue"
    import mapboxgl from "mapbox-gl";
    import "mapbox-gl/dist/mapbox-gl.css";
    import MapboxDraw from "@mapbox/mapbox-gl-draw";
    import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
    import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
    import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
    import * as turf from '@turf/turf'
    
    mapboxgl.accessToken =
        "pk.eyJ1IjoiYWFyY2lsYTE4IiwiYSI6ImNsM2V6YWdscjBuZDMzY3A3M2FtMDl6YWgifQ.adh5HQ_qhIy3cjG1a-pSAQ";
    
    const props = defineProps(["center","id","locations_area", "area"]);
    const emit = defineEmits(['selectedLocation'])

    const selectLocation = ref(true)
    const selectedLocation = ref([])
    
    onMounted(() => {
        const map = new mapboxgl.Map({
            container: props.id, // container ID
            style: "mapbox://styles/mapbox/satellite-streets-v11", // style URL
            center: props.center,
            zoom: 12, // starting zoom
            cooperativeGestures: false,
            projection: "globe", // display the map as a 3D globe
        });
    
        const marker = new mapboxgl.Marker();
        map.on('click', add_marker.bind(this));

        function add_marker (event) {
            var coordinates = event.lngLat;
            selectedLocation.value = [coordinates.lng,coordinates.lat]
            console.log(selectedLocation.value);
            marker.setLngLat(coordinates).addTo(map);
            emit('selectedLocation',selectedLocation.value);
        }

        // Add geolocate control to the map.
        map.addControl(
        new mapboxgl.GeolocateControl({
        positionOptions: {
        enableHighAccuracy: true
        },
        // When active the map will receive updates to the device's location as it changes.
        trackUserLocation: true,
        // Draw an arrow next to the location dot to indicate which direction the device is heading.
        showUserHeading: true
        })
        );

        if (props.area == true) {
        map.on("load", () => {
            // Add a data source containing GeoJSON data.
            map.addSource("maine", {
                type: "geojson",
                data: {
                    type: "Feature",
                    geometry: {
                        type: "Polygon",
                        // These coordinates outline Maine.
                        coordinates: [
                            props.locations_area,
                        ],
                    },
                },
            });

            // Add a new layer to visualize the polygon.
            map.addLayer({
                id: "maine",
                type: "fill",
                source: "maine", // reference the data source
                layout: {},
                paint: {
                    "fill-color": "#ebc634", // blue color fill
                    "fill-opacity": 0.5,
                },
            });

        });

    }
        map.addControl(
            new MapboxGeocoder({
                accessToken: mapboxgl.accessToken,
                mapboxgl: mapboxgl
            }),
            'top-left'
        );
        map.addControl(new mapboxgl.FullscreenControl());
        map.addControl(new mapboxgl.NavigationControl());
    
    });
    </script>
    
    <template lang="">
        <div>
            <div :id="props.id" class="w-full h-96"></div>
        </div>
    </template>
    
    <style lang=""></style>
    
